module.exports = __webpack_public_path__ + "img/jsxcl.e1d848a.png";